<template>
  <SiteHeader/>
  <div class="placeholder">
    <div>
      <h4>#управляйбудущим</h4><br>
      <h2>Дорогие участники, <br> до встречи <br/>в&nbsp;2025&nbsp;году</h2>
    </div>
  </div>
  <div class="content-block" id="photo_gallery">
    <div class="content-block__inner">
      <h2 class="content-block__title">Фотогалерея</h2>
      <MediaSlider slider-id="photo" wrapper-id="photo_gallery"/>
      <div class="more-buttons">
        <a href="https://files.sberdisk.ru/s/Bg4tlEQKg76pmJo" target="_blank" class="button">
          Смотреть архив
        </a>
      </div>
    </div>
  </div>
  <div class="content-block" id="video_gallery" :style="{'background-image': `url(${require('@/assets/img/main-page/4.png')})`}">
    <div class="content-block__inner">
      <h2 class="content-block__title">Видеогалерея</h2>
      <MediaSlider slider-id="video" wrapper-id="video_gallery" video/>
    </div>
  </div>
  <div class="content-block content-block_dark content-block_no-bottom-padding">
    <div class="content-block__inner">
      <h2 class="content-block__title"><span>История Зелёного Марафона</span></h2>
      <HistoryBlock/>
      <div class="content-block__divider"></div>
    </div>
  </div>
  <SiteFooter/>
  <CookieAlert>
    <p>Мы используем cookies для улучшения работы сайта и повышения удобства его использования. Условия использования описаны в&nbsp;<a href="https://sberbank.com/common/files/greenmarathon_new/2024_preview/privacy_v1.pdf" target="_blank">Политике конфиденциальности</a></p>
  </CookieAlert>
</template>

<script>
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import HistoryBlock from "@/components/HistoryBlock";
import MediaSlider  from "@/components/MediaSlider";
import CookieAlert  from "@/components/CookieAlert";

export default {
  name: 'App',
  components: {
    SiteHeader, SiteFooter, HistoryBlock, MediaSlider, CookieAlert
  }
}
</script>
